/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    let group = super.model(...arguments);

    return hash({
      group,
      subjects: this.store.query('goals/subject', { trackable: true }),
      milestones: this.store.query('milestones/milestone', {
        progressionType: ProgressionType.PROGRESSION,
      }),
      milestoneSets: this.store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
    });
  }

  afterModel(model) {
    model.milestones = model.milestones
      .slice()
      .sort(
        (a, b) =>
          a.sequence - b.sequence ||
          (a.label || '').localeCompare(b.label || ''),
      );
  }

  resetController(controller) {
    controller.set('allowProfileUploads', false);
    super.resetController(...arguments);
  }
}
